export enum LabelType {
	CORE = 'Core',
	CUSTOM = 'Custom'
}

export enum PanelMode {
	ADD = 'add',
	EDIT = 'edit'
}

export interface Label {
	key: string;
	displayName: string;
	type: LabelType;
	values: string[];
}
